export { default } from './PersonalDataConsentLabel';
